<div class="gw-flex gw-flex-col">
  <header
    class="gw-bg-background-elevation-1 gw-sticky gw-top-0 gw-z-27"
    [ngClass]="{'border-header': isNavigationCollapsed}"
  >
    <div
      class="gw-h-full gw-flex gw-items-center gw-justify-between gw-gap-2x-small gw-max-w-full gw-box-border"
    >
      <button
        class="gw-header-mobile-menu gw-hidden md:gw-hidden gw-flex gw-items-center gw-justify-center gw-w-8 gw-h-8 gw-rounded-lg gw-bg-transparent hover:gw-bg-background-neutral-1-hover gw-transition-colors gw-duration-200 gw-cursor-pointer"
        title="Menu"
        type="button"
        (click)="toggleNavigation()"
        aria-label="Toggle navigation menu"
      >
        <gatewee-icon
          icon="@tui.menu"
          iconStyle="outline"
          size="16px"
        ></gatewee-icon>
      </button>

      <div
        class="gw-flex gw-items-center gw-justify-center gw-w-[110px] md:gw-w-[200px] gw-min-w-[110px] md:gw-min-w-[200px] gw-flex-shrink-0 gw-pl-0 gw-h-full gw-max-h-[56px]"
      >
        <button
          *ngIf="logoUrl"
          type="button"
          class="gw-p-0 gw-m-0 gw-border-0 gw-bg-transparent gw-cursor-pointer gw-flex gw-items-center gw-justify-center focus:gw-outline-none focus-visible:gw-ring-2 focus-visible:gw-ring-border-focus focus-visible:gw-rounded"
          (click)="onLogoClick()"
          aria-label="Logo"
        >
          <img
            [src]="logoUrl"
            alt=""
            class="gw-w-auto gw-object-contain gw-max-h-[40px] gw-block gw-pointer-events-none"
          />
        </button>
      </div>

      <ul
        class="gw-pl-0 gw-flex gw-items-center md:gw-space-x-2 md:gw-space-x-4 gw-list-none gw-m-0 gw-min-w-0 gw-flex-shrink"
      >
        <li
          *ngIf="effectiveProfile?.recipient?.sandbox"
          class="gw-hidden sm:gw-block"
        >
          <div
            class="gw-flex gw-items-center gw-px-2 md:gw-px-3 gw-py-1.5 md:gw-py-2 gw-rounded-lg gw-bg-background-neutral-1 gw-border gw-border-border-normal"
          >
            <span
              class="gw-text-xs gw-font-semibold gw-text-status-warning gw-mr-1 md:gw-mr-2"
            >
              Sandbox
            </span>
            <span
              class="gw-text-xs gw-text-text-secondary gw-hidden md:gw-inline"
            >
              Ambiente de testes
            </span>
          </div>
        </li>

        <li
          class="gw-mx-1 md:gw-mx-3 gw-flex-shrink-0 web-language"
          *ngIf="!isMobileLayout && config?.showLanguageSelector !== false"
        >
          <button
            tuiButton
            appearance="flat"
            size="m"
            type="button"
            tuiDropdownAlign="right"
            [tuiDropdown]="languageDropdown"
            [(tuiDropdownOpen)]="isLanguageDropdownOpen"
            [tuiAppearanceState]="isLanguageDropdownOpen ? 'active' : null"
            class="gw-flex bg-button gw-items-center gw-gap-2 gw-px-2 md:gw-px-3 gw-py-1.5 md:gw-py-2 gw-rounded-lg gw-bg-background-base gw-border gw-border-border-normal gw-transition-colors gw-duration-200"
            aria-label="Selecionar idioma"
          >
            <img
              [src]="selectedLanguageImage"
              alt=""
              class="gw-w-5 gw-h-5 gw-rounded-sm gw-object-cover"
            />

            <gatewee-icon
              icon="@tui.chevron-down"
              iconStyle="primary"
              size="16px"
              class="gw-text-text-secondary"
            ></gatewee-icon>
          </button>
        </li>

        <li *ngIf="devMode" class="gw-hidden md:gw-block">
          <button
            tuiButton
            appearance="flat"
            size="m"
            type="button"
            class="gw-flex bg-button gw-items-center gw-px-2 md:gw-px-3 gw-py-1.5 md:gw-py-2 gw-rounded-lg gw-bg-background-base gw-border gw-border-border-normal gw-transition-colors gw-duration-200"
            (click)="toggleTheme()"
          >
            <gatewee-icon
              *ngIf="
                config?.branding?.style?.theme !== 'dark';
                else darkIconHeader
              "
              icon="@tui.sun"
              iconStyle="primary"
              size="18px"
            ></gatewee-icon>

            <ng-template #darkIconHeader>
              <gatewee-icon
                icon="@tui.moon"
                iconStyle="primary"
                size="18px"
              ></gatewee-icon>
            </ng-template>
          </button>
        </li>

        <li
          *ngIf="config?.showTaskbarToggle && config?.tasks !== undefined"
          class="gw-relative gw-flex-shrink-0"
        >
          <button
            tuiButton
            appearance="flat"
            size="m"
            type="button"
            tuiDropdownAlign="right"
            [tuiDropdown]="taskbarDropdown"
            [(tuiDropdownOpen)]="isTaskbarDropdownOpen"
            [tuiAppearanceState]="isTaskbarDropdownOpen ? 'active' : null"
            class="gw-flex bg-button gw-items-center gw-px-2 md:gw-px-3 gw-py-1.5 md:gw-py-2 gw-rounded-lg gw-bg-background-base gw-border gw-border-border-normal gw-transition-colors gw-duration-200"
            aria-label="Tarefas em andamento"
          >
            <gatewee-icon
              icon="@phi.list-checks"
              iconStyle="primary"
              size="18px"
            ></gatewee-icon>
            <span
              *ngIf="hasActiveTasks"
              class="gw-absolute gw-top-1 gw-right-1 gw-w-2 gw-h-2 gw-rounded-full gw-bg-status-negative"
            ></span>
          </button>
        </li>

        <li class="divider gw-list-none" aria-hidden="true"></li>

        <li class="gw-relative">
          <button
            tuiButton
            appearance="flat"
            size="m"
            type="button"
            tuiDropdownAlign="center"
            [tuiDropdown]="profileDropdown"
            [tuiDropdownSided]="false"
            [(tuiDropdownOpen)]="isProfileDropdownOpen"
            class="gw-flex gw-items-center gw-space-x-2 button-avatar md:gw-space-x-3 gw-px-2 md:gw-px-3 gw-py-1.5 md:gw-py-2 hover-none gw-rounded-lg gw-transition-colors gw-duration-200 gw-min-w-0"
          >
            <ng-container *ngIf="effectiveProfile !== null">
              <div
                class="gw-text-right gw-min-w-0 gw-max-w-[120px] sm:gw-max-w-[160px] md:gw-max-w-[220px]"
              >
                <p
                  class="gw-text-sm gw-font-semibold gw-text-text-primary gw-m-0 gw-truncate"
                >
                  {{ effectiveProfile.name }}
                </p>
                <p
                  class="gw-text-xs gw-text-text-secondary gw-m-0 gw-truncate gw-uppercase"
                >
                  {{ effectiveProfile.role || '' }}
                </p>
              </div>

              <tui-avatar
                [src]="
                  effectiveProfile.profilePhoto ||
                  (effectiveProfile.name || '' | tuiInitials)
                "
                [style.background]="
                  !effectiveProfile.profilePhoto
                    ? (effectiveProfile.name || '' | tuiAutoColor)
                    : null
                "
                [round]="true"
                [size]="'m'"
                class="gw-flex-shrink-0"
              ></tui-avatar>
            </ng-container>
          </button>

          <ng-template #profileDropdown let-close>
            <div
              class="gw-min-w-[240px] gw-rounded-lg gw-border gw-border-border-normal gw-shadow-lg gw-bg-background-elevation-1 gw-overflow-hidden"
            >
              @for (item of config?.profileMenuAdditionalItems; track
              item.title) {
              <button
                type="button"
                class="gw-flex gw-w-full gw-items-center gw-justify-start gw-gap-3 gw-px-4 gw-py-3 gw-text-left gw-text-sm gw-text-text-primary hover:gw-bg-background-neutral-1-hover gw-transition-colors gw-cursor-pointer"
                (click)="navigateTo(item.route ?? ''); close()"
              >
                <gatewee-icon
                  [icon]="item.icon ?? ''"
                  iconStyle="primary"
                  size="18px"
                ></gatewee-icon>
                <span class="gw-font-medium">{{ item.title | translate }}</span>
              </button>
              }
              <button
                *ngIf="
                  config?.showMyFeesShortcut === true &&
                  config?.onMyFeesNavigate
                "
                type="button"
                class="gw-flex gw-w-full gw-items-center gw-justify-start gw-gap-3 gw-px-4 gw-py-3 gw-text-left gw-text-sm gw-text-text-primary hover:gw-bg-background-neutral-1-hover gw-transition-colors gw-cursor-pointer"
                (click)="navigateToMyFees(); close()"
              >
                <gatewee-icon
                  icon="@phi.percent"
                  iconStyle="primary"
                  size="18px"
                ></gatewee-icon>
                <span class="gw-font-medium">{{
                  'nav.menu.myFees' | translate
                }}</span>
              </button>
              <button
                type="button"
                class="gw-flex gw-w-full gw-items-center gw-justify-start gw-gap-3 gw-px-4 gw-py-3 gw-text-left gw-text-sm gw-text-text-primary hover:gw-bg-background-neutral-1-hover gw-transition-colors gw-cursor-pointer"
                (click)="
                  navigateTo(config?.profileRoute ?? '/panel/profile'); close()
                "
              >
                <gatewee-icon
                  icon="@phi.user"
                  iconStyle="primary"
                  size="18px"
                  class="gw-text-status-negative"
                ></gatewee-icon>

                <span class="gw-font-medium">{{
                  'nav.menu.profile' | translate
                }}</span>
              </button>
              <button
                type="button"
                class="gw-flex gw-w-full gw-items-center gw-justify-start gw-gap-3 gw-px-4 gw-py-3 gw-text-left gw-text-sm gw-text-text-primary hover:gw-bg-background-neutral-1-hover gw-transition-colors gw-cursor-pointer"
                (click)="logout(); close(); isProfileDropdownOpen = false"
              >
                <gatewee-icon
                  icon="@phi.sign-out"
                  iconStyle="primary"
                  size="18px"
                  class="gw-text-status-negative"
                ></gatewee-icon>

                <span class="gw-font-medium">Logout</span>
              </button>
            </div>
          </ng-template>
        </li>
      </ul>
    </div>
  </header>

  <div
    *ngIf="!isNavigationCollapsed"
    class="gw-h-[56px] gw-bg-background-elevation-1 sub-header"
  >
    <div
      class="gw-mx-1 md:gw-mx-3 gw-flex-shrink-0 mobile-language"
      *ngIf="isMobileLayout && config?.showLanguageSelector !== false"
    >
      <button
        tuiButton
        appearance="flat"
        size="m"
        type="button"
        tuiDropdownAlign="right"
        [tuiDropdown]="languageDropdown"
        [(tuiDropdownOpen)]="isLanguageDropdownOpen"
        [tuiAppearanceState]="isLanguageDropdownOpen ? 'active' : null"
        class="gw-flex gw-items-center gw-gap-2 gw-px-2 md:gw-px-3 gw-py-1.5 md:gw-py-2 gw-rounded-lg gw-bg-background-neutral-1 gw-border gw-border-border-normal hover:gw-bg-background-neutral-1-hover gw-transition-colors gw-duration-200"
        aria-label="Selecionar idioma"
      >
        <img
          [src]="selectedLanguageImage"
          alt=""
          class="gw-w-5 gw-h-5 gw-rounded-sm gw-object-cover"
        />

        <span class="gw-hidden md:gw-inline gw-text-xs md:gw-text-sm">
          {{ selectedLanguageLabel }}
        </span>

        <gatewee-icon
          icon="@tui.chevron-down"
          iconStyle="primary"
          size="16px"
          class="gw-text-text-secondary"
        ></gatewee-icon>
      </button>
    </div>

    <div *ngIf="devMode" class="gw-block">
      <button
        tuiButton
        appearance="flat"
        size="m"
        type="button"
        class="gw-flex bg-button gw-items-center gw-px-2 md:gw-px-3 gw-py-1.5 md:gw-py-2 gw-rounded-lg gw-bg-background-neutral-1 gw-border gw-border-border-normal hover:gw-bg-background-neutral-1-hover gw-transition-colors gw-duration-200"
        (click)="toggleTheme()"
      >
        <gatewee-icon
          *ngIf="config?.branding?.style?.theme !== 'dark'; else darkIconSub"
          icon="@tui.sun"
          iconStyle="primary"
          size="18px"
        ></gatewee-icon>

        <ng-template #darkIconSub>
          <gatewee-icon
            icon="@tui.moon"
            iconStyle="primary"
            size="18px"
          ></gatewee-icon>
        </ng-template>

        <span
          class="gw-hidden lg:gw-inline gw-ml-2 gw-text-xs gw-font-semibold"
        >
          DEVMODE
        </span>
      </button>
    </div>
  </div>

  <ng-template #taskbarDropdown>
    <div
      class="gw-min-w-[280px] gw-max-w-[340px] gw-rounded-lg gw-border gw-border-border-normal gw-shadow-lg gw-bg-background-elevation-1 gw-overflow-hidden"
    >
      <ng-container *ngIf="(config?.tasks ?? []).length > 0; else noTasks">
        <div
          *ngFor="let task of config?.tasks"
          class="gw-flex gw-flex-col gw-gap-1 gw-px-4 gw-py-3 gw-border-b gw-border-border-normal last:gw-border-b-0"
        >
          <div class="gw-flex gw-justify-between gw-items-center">
            <span
              class="gw-text-sm gw-font-medium gw-text-text-primary gw-truncate"
              >{{ getTaskLabel(task) }}</span
            >
            <span class="gw-text-xs gw-text-text-secondary gw-capitalize">{{
              task.status
            }}</span>
          </div>
          <progress
            tuiProgressBar
            [value]="
              task.progress?.progress ?? (task.status === 'pending' ? 0 : 100)
            "
            max="100"
            size="s"
          ></progress>
        </div>
      </ng-container>

      <ng-template #noTasks>
        <div
          class="gw-flex gw-flex-col gw-items-center gw-gap-2 gw-px-4 gw-py-6 gw-text-center"
        >
          <gatewee-icon
            icon="@phi.check-circle"
            iconStyle="primary"
            size="32px"
            class="gw-text-status-success"
          ></gatewee-icon>
          <p class="gw-text-sm gw-text-text-secondary gw-m-0">
            {{ 'features.tasks.empty.active' | translate }}
          </p>
        </div>
      </ng-template>

      <a
        *ngIf="config?.tasksRoute"
        [routerLink]="config?.tasksRoute"
        class="gw-flex gw-justify-center gw-px-4 gw-py-3 gw-border-t gw-border-border-normal gw-text-xs gw-text-primary gw-underline hover:gw-bg-background-neutral-1-hover gw-transition-colors"
        (click)="isTaskbarDropdownOpen = false"
      >
        {{ 'features.tasks.seeAllTasks' | translate }}
      </a>
    </div>
  </ng-template>

  <ng-template #languageDropdown let-close>
    <div
      class="gw-rounded-lg gw-border gw-border-border-normal gw-shadow-lg gw-bg-background-elevation-1 gw-overflow-hidden"
    >
      <button
        type="button"
        class="gw-cursor-pointer gw-flex gw-items-center gw-gap-3 gw-px-4 gw-py-3 gw-text-sm gw-text-text-primary hover:gw-bg-background-neutral-1-hover gw-transition-colors"
        *ngFor="let lang of languageOptions"
        (click)="changeLanguageByCode(lang.code, close)"
      >
        <img
          [src]="languageImages[lang.code]"
          alt=""
          class="gw-w-5 gw-h-5 gw-rounded-sm gw-object-cover"
        />
        <span class="gw-font-medium">{{ lang.label }}</span>
      </button>
    </div>
  </ng-template>
</div>
